export default __webpack_public_path__ + "static/media/P940_RoHS.3a2c3a3a.pdf";